import React from "react";
import { HiOutlineOfficeBuilding } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneCompanies } from "../../../lib/sysNavigation/SysNavigation";

type CompanyRow = {
  ministry_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<CompanyRow>
    type={_TYPES_.COMPANY}
    title="Companies"
    subtitle="Organisations listed on the public site."
    icon={<HiOutlineOfficeBuilding className="h-5 w-5" />}
    addRoute="/data/company/add"
    editRoute="/data/company/edit"
    pushOne={pushOneCompanies}
    dataKey="companies"
    countKey="companiesCount"
    idField="ministry_id"
  />
);

export default Overview;
